<template>
  <v-card v-if="this.category!==null">
    <v-card-title>
      Summary table for {{ this.category.classification.nameClassification }} with {{ this.category.nameCategory }}.
    </v-card-title>
    <v-card-text>
      The table below shows preferred data for {{ this.category.classification.nameClassification }} with {{ this.category.nameCategory }} in the database.
      To reference material from the datasheets please cite the appropriate volume in Atmospheric Chemistry and Physics from the list <a target="_blank" href="http://www.atmos-chem-phys.net/special_issue8.html">here</a>
      This summary table can be downloaded <a :href="csvFileEndpoint">here</a>.
    </v-card-text>
    <slot></slot>
  </v-card>
  <v-card  v-else>
    <v-card-title>
      <h3>Summary table for {{ this.classification.nameClassification }}.</h3>
    </v-card-title>
    <v-card-text>
      The table below shows preferred data for {{ this.classification.nameClassification }} reaction in the database.
      To reference material from the datasheets please cite the appropriate volume in Atmospheric Chemistry and Physics from the list <a target="_blank" href="http://www.atmos-chem-phys.net/special_issue8.html">here</a>
      This summary table can be downloaded <a :href="csvFileEndpoint">here</a>.
    </v-card-text>
    <slot></slot>
  </v-card>
</template>

<script>
export default {
  components: {},
  name: 'HeaderSummaryTable',

  props: ['classification', "category"],
  computed: {
    csvFileEndpoint() {
      return this.category==null ? this.axios.defaults.baseURL+"classifications/"+this.classification.codeClassification+"/preferred-values" : this.axios.defaults.baseURL+"categories/"+this.category.codeCategory+"/preferred-values";
    }
  }
}
</script>

<style scoped>
</style>
